import { render, staticRenderFns } from "./packageDefinition.vue?vue&type=template&id=45e2f18e&scoped=true"
import script from "./packageDefinition.vue?vue&type=script&lang=js"
export * from "./packageDefinition.vue?vue&type=script&lang=js"
import style0 from "./packageDefinition.vue?vue&type=style&index=0&id=45e2f18e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2f18e",
  null
  
)

export default component.exports